{
  "Job roles": "Job roles",
  "My roles": "My roles",
  "Other roles": "Other roles",
  "Add participants": "Add participants",
  "Agent": "Agent",
  "automated": "automated",
  "Learning items": "Learning items",
  "Assignment groups": "Assignment groups",
  "Assignment group": "Assignment group",
  "Only published": "Only published",
  "No participants in the assignment group": "No participants in the assignment group",
  "managed": "managed",
  "Manually added": "Manually added",
  "Participants": "Participants",
  "participants": "participants",
  "Rules": "Rules",
  "Type": "Type",
  "Assignments": "Assignments",
  "Items": "Items",
  "mandatory": "Required",
  "suggested": "Recommended",
  "global": "Global",
  "role": "Role",
  "in tab {{tab}}": "in tab {{tab}}",
  "Removed Assignment group: {{name}}": "Removed Assignment group: {{name}}",
  "Assignment group created successfully": "Assignment group created successfully",
  "Assignment group saved successfully": "Assignment group saved successfully",
  "Select type": "Select type",
  "Select a column": "Select a column",
  "Save rules": "Save rules",
  "Preview changed rules": "Preview changed rules",
  "rule": "rule",
  "rule_plural": "rules",
  "condition": "condition",
  "participant": "participant",
  "assignment": "assignment",
  "published": "Published",
  "unpublished": "Unpublished",
  "not-published": "Not published",
  "Filter status": "Filter status",
  "Empty": "Empty",
  "ANY": "any",
  "ALL": "all",
  "AND": "AND",
  "OR": "OR",
  "Select all of the users that meet": "Select all of the users that meet",
  "of these rules": "of these rules",
  "of these conditions": "of these conditions",
  "if": "if",
  "Add rule": "Add rule",
  "Add condition": "Add condition",
  "E-mail addresses that couldn't be added": "E-mail addresses that couldn't be added",
  "users-added": "Added {{added}} participant(s)",
  "users-added-with-duplicates": "Added {{added}} participant(s), {{duplicates}} existing participant(s) ignored",
  "users-added-none-with-duplicates": "No participants added and {{duplicates}} existing participant(s) ignored",
  "You successfully removed {{email}} from participants": "You successfully removed {{email}} from participants",
  "Name": "Name",
  "Learners": "Learners",
  "Space": "Space",
  "Status": "Status",
  "auto-join-webinar": "Auto-join webinar for participants",
  "enable-automatic-webinar": "Enables automatic webinar seats for participants without manual intervention",
  "remove-learning-item-suffix": "learning item from this assignment"
}
